module.exports = __webpack_public_path__ + "static/img/kehu_list.5635973d.png";